export interface WidgetHost {
  addWidgetById(id: string): void;
  removeWidgetById(id: string): void;
  get activeWidgetIds(): string[];
  get hostId(): string;
  get currentViewId(): string;
  setWidgetPath(id: string, path: string): void;
  registerWidgetNavigator(id: string, navigate: (path: string) => void): () => void;
  registerActiveWidgetSelector(select: (id: string, path?: string) => void): () => void;
  saveWidgetPreferences<T>(id: string, t: T): Promise<T>;
  getWidgetPreferences<T>(id: string): Promise<T>;
  //sendNotification(notification: Notification): void;
}

export async function waitForRegisteredNavigator(
  navigators: Map<string, (path: string) => void>,
  id: string,
  attempts = 20,
  intervalMs = 100,
): Promise<((path: string) => void) | undefined> {
  for (let i = 0; i < attempts; i++) {
    const navigate = navigators.get(id);
    if (navigate) return navigate;
    await new Promise(resolve => setTimeout(resolve, intervalMs));
  }
  return undefined;
}
